// extracted by mini-css-extract-plugin
module.exports = {"FormTabs":"form-tabs_FormTabs__ZwN9A","FormTabs__tab":"form-tabs_FormTabs__tab__Ga_wG","FormTabs__tab--disabled":"form-tabs_FormTabs__tab--disabled__owZ4Q"};